/**
 * @generated SignedSource<<060afa604682161f88d47075540fc674>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MATSchoolTypeEnum = "elementary_school" | "high_school" | "middle_school" | "%future added value";
export type MATSchoolYearTypeEnum = "elementary_school_3" | "elementary_school_4" | "elementary_school_5" | "elementary_school_6" | "high_school_1" | "high_school_2" | "high_school_3" | "high_school_N" | "middle_school_1" | "middle_school_2" | "middle_school_3" | "%future added value";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type MATInternalUserFilter = {
  AND?: MATInternalUserFilter | null;
  NOT?: MATInternalUserFilter | null;
  OR?: MATInternalUserFilter | null;
  distinct?: boolean | null;
  friendTag_Exact?: string | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  phoneNumber_Exact?: string | null;
  premium_Exists_In?: ReadonlyArray<boolean> | null;
  schoolType_In?: ReadonlyArray<MATSchoolTypeEnum> | null;
  schoolYearType_Exact?: MATSchoolYearTypeEnum | null;
  search?: string | null;
  sequence_Exact?: number | null;
};
export type MATInternalUserOrder = {
  dateJoined?: Ordering | null;
  id?: Ordering | null;
  studentprofile_ChargeExpirationDate?: Ordering | null;
  username?: Ordering | null;
};
export type InternalUserPaginatorRefreshQuery$variables = {
  after?: string | null;
  filters?: MATInternalUserFilter | null;
  first?: number | null;
  order?: MATInternalUserOrder | null;
};
export type InternalUserPaginatorRefreshQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InternalUserPaginator_query">;
};
export type InternalUserPaginatorRefreshQuery = {
  response: InternalUserPaginatorRefreshQuery$data;
  variables: InternalUserPaginatorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalUserPaginatorRefreshQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "InternalUserPaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternalUserPaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MATInternalUserConnection",
        "kind": "LinkedField",
        "name": "internalUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MATInternalUserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MATInternalUser",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "loginId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userSequence",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filters",
          "order"
        ],
        "handle": "connection",
        "key": "InternalUserPaginator_query_internalUsers",
        "kind": "LinkedHandle",
        "name": "internalUsers"
      }
    ]
  },
  "params": {
    "cacheID": "7d97b2ba2b41ad3e6f5f661f3184efeb",
    "id": null,
    "metadata": {},
    "name": "InternalUserPaginatorRefreshQuery",
    "operationKind": "query",
    "text": "query InternalUserPaginatorRefreshQuery(\n  $after: String\n  $filters: MATInternalUserFilter\n  $first: Int\n  $order: MATInternalUserOrder\n) {\n  ...InternalUserPaginator_query_2rfEMg\n}\n\nfragment InternalUserPaginator_query_2rfEMg on Query {\n  internalUsers(filters: $filters, order: $order, first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        userName\n        loginId\n        userSequence\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87a11cbe6d731d580fa03aab9cfa08a7";

export default node;
